(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-hulkapps-backup"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["naturelle-upsell-modal"]) return;
  try {
    
  (function () {
    const SECTION_SELECTOR = '.upsell-modal';
    const ROW_SELECTOR = '[data-upsell-row]';

    let cartCache = null;
    let initialised = false;

    function moneyFmt(cents) {
      if (window.Shopify && window.Shopify.formatMoney) {
        return window.Shopify.formatMoney(cents);
      }
      return '$' + (cents / 100).toFixed(2);
    }

    function fetchCart() {
      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) { cartCache = c; return c; });
    }

    function renderCartSummary(modal, cart) {
      if (!modal || !cart) return;

      const lineEl    = modal.querySelector('[data-upsell-cart-line]');
      const wasEl     = modal.querySelector('[data-upsell-cart-was]');
      const nowEl     = modal.querySelector('[data-upsell-cart-now]');
      const savingEl  = modal.querySelector('[data-upsell-cart-saving]');

      const footerTot = modal.querySelector('[data-upsell-footer-total]');
      const footerSav = modal.querySelector('[data-upsell-footer-saving]');

      // Cart summary line — count + first item
      if (lineEl) {
        if (cart.item_count === 0) {
          lineEl.textContent = 'Your cart is empty.';
        } else {
          const first = cart.items[0];
          const firstTitle = first ? (first.product_title || first.title) : '';
          const itemWord = cart.item_count === 1 ? 'item' : 'items';
          let line = cart.item_count + ' ' + itemWord;
          if (firstTitle) line += ' · ' + firstTitle;
          // Add scent / variant detail if available
          if (first && first.variant_options && first.variant_options.length > 0 && first.variant_options[0] !== 'Default Title') {
            line += ' · ' + first.variant_options.join(', ');
          }
          lineEl.textContent = line;
        }
      }

      // Cart subtotal — items_subtotal_price (before discounts) vs total_price (after)
      if (nowEl) nowEl.textContent = moneyFmt(cart.total_price);
      if (wasEl) {
        if (cart.total_discount > 0) {
          wasEl.textContent = moneyFmt(cart.items_subtotal_price);
          wasEl.hidden = false;
        } else {
          wasEl.hidden = true;
        }
      }
      if (savingEl) {
        if (cart.total_discount > 0 && cart.items_subtotal_price > 0) {
          const pct = Math.round(cart.total_discount / cart.items_subtotal_price * 100);
          savingEl.textContent = 'SAVING ' + pct + '%';
          savingEl.hidden = false;
        } else {
          savingEl.hidden = true;
        }
      }

      // Footer totals
      if (footerTot) footerTot.textContent = moneyFmt(cart.total_price);
      if (footerSav) {
        if (cart.total_discount > 0) {
          footerSav.textContent = 'SAVING ' + moneyFmt(cart.total_discount);
          footerSav.hidden = false;
        } else {
          footerSav.hidden = true;
        }
      }
    }

    function wireRow(row) {
      if (row.dataset.upsellRowInit === '1') return;
      row.dataset.upsellRowInit = '1';

      const qtyEl = row.querySelector('[data-upsell-qty]');
      const dec   = row.querySelector('[data-upsell-dec]');
      const inc   = row.querySelector('[data-upsell-inc]');
      const addBtn = row.querySelector('[data-upsell-add]');
      const variantSelect = row.querySelector('[data-upsell-variant-select]');
      const variantInput  = row.querySelector('[data-upsell-variant-input]');
      const wasEl = row.querySelector('[data-upsell-was]');
      const nowEl = row.querySelector('[data-upsell-now]');
      const errorEl = row.querySelector('[data-upsell-error]');
      const discountPct = parseInt(row.dataset.discountPct, 10) || 0;

      function getQty() {
        return parseInt(qtyEl.textContent, 10) || 1;
      }
      function setQty(n) {
        const v = Math.max(1, Math.min(99, n));
        qtyEl.textContent = v;
      }

      function getVariantId() {
        if (variantSelect) return parseInt(variantSelect.value, 10);
        if (variantInput)  return parseInt(variantInput.value, 10);
        return null;
      }

      function updatePrice() {
        if (!variantSelect) return;
        const opt = variantSelect.selectedOptions[0];
        if (!opt) return;
        const wasCents = parseInt(opt.dataset.priceCents, 10) || 0;
        const nowCents = Math.round(wasCents * (100 - discountPct) / 100);
        if (wasEl && discountPct > 0) wasEl.textContent = moneyFmt(wasCents);
        if (nowEl) nowEl.textContent = moneyFmt(nowCents);
      }

      if (dec) dec.addEventListener('click', function () { setQty(getQty() - 1); });
      if (inc) inc.addEventListener('click', function () { setQty(getQty() + 1); });
      if (variantSelect) variantSelect.addEventListener('change', updatePrice);

      if (addBtn) {
        addBtn.addEventListener('click', function () {
          const variantId = getVariantId();
          const qty = getQty();
          if (!variantId || !window.ON || !window.ON.cart || !window.ON.cart.add) return;

          // Clear any prior "couldn't add" message before retrying.
          if (errorEl) { errorEl.hidden = true; }

          addBtn.disabled = true;
          const originalText = addBtn.textContent;
          addBtn.textContent = 'ADDING…';

          window.ON.cart.add({ id: variantId, quantity: qty })
            .then(function () { return fetchCart(); })
            .then(function (cart) {
              const modal = row.closest(SECTION_SELECTOR);
              renderCartSummary(modal, cart);
              addBtn.textContent = '✓ ADDED';
              addBtn.dataset.added = 'true';
              if (errorEl) { errorEl.hidden = true; }
              setTimeout(function () {
                addBtn.textContent = '+ ADD';
                addBtn.dataset.added = 'false';
                addBtn.disabled = false;
              }, 1400);
            })
            .catch(function (err) {
              console.error('[upsell-modal] add failed', err);
              addBtn.textContent = originalText;
              addBtn.disabled = false;
              if (errorEl) { errorEl.hidden = false; }
            });
        });
      }
    }

    function initSection(modal) {
      if (modal.dataset.upsellInit === '1') return;
      modal.dataset.upsellInit = '1';

      // Wire each upsell row
      modal.querySelectorAll(ROW_SELECTOR).forEach(wireRow);

      // Hijack cart drawer checkout form submission
      const hasUpsells = modal.querySelectorAll(ROW_SELECTOR).length > 0;
      if (hasUpsells && !initialised) {
        initialised = true;

        document.addEventListener('submit', function (e) {
          const form = e.target;
          if (!form || !form.classList || !form.classList.contains('naturelle-cart__checkout-form')) return;

          // Don't intercept if no items in cart
          if (cartCache && cartCache.item_count === 0) return;

          // Session guard — only nag once per browser session. If the modal
          // has already been shown this session, let the form submit straight
          // through to /checkout. Wrapped in try/catch so private-browsing
          // (which throws on sessionStorage access) still gets normal flow.
          try {
            if (sessionStorage.getItem('ons-upsell-shown')) return;
          } catch (_) { /* storage unavailable — proceed with modal */ }

          e.preventDefault();

          // Close cart drawer if open
          if (window.ON && typeof window.ON.closeDrawer === 'function') {
            window.ON.closeDrawer('cart');
          }

          // Open the modal unconditionally after the cart drawer's close
          // animation. Cart summary populates best-effort — a network blip
          // shouldn't strand the user with the drawer closed and no modal.
          setTimeout(function () {
            if (window.ON && typeof window.ON.openDrawer === 'function') {
              window.ON.openDrawer('upsell');
              document.body.classList.add('has-upsell-open');
              try { sessionStorage.setItem('ons-upsell-shown', '1'); } catch (_) {}
            }
          }, 240);

          fetchCart()
            .then(function (cart) { renderCartSummary(modal, cart); })
            .catch(function (err) { console.error('[upsell-modal] cart fetch failed', err); });
        });

        // Listen for drawer close to remove body lock
        if (window.ON && typeof window.ON.on === 'function') {
          window.ON.on(document, 'click', function (e) {
            const closer = e.target.closest('[data-on-drawer-close]');
            const backdrop = e.target.closest('[data-on-drawer-backdrop="upsell"]');
            if (closer || backdrop) {
              document.body.classList.remove('has-upsell-open');
            }
          });
        }
      }
    }

    function initAll(scope) {
      (scope || document).querySelectorAll(SECTION_SELECTOR).forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-contact-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.faqInit === '1') return;
      root.dataset.faqInit = '1';

      var rows = root.querySelectorAll('[data-faq-row]');
      rows.forEach(function (row) {
        var toggle = row.querySelector('[data-faq-toggle]');
        if (!toggle) return;
        toggle.addEventListener('click', function () {
          var isOpen = row.dataset.open === 'true';
          rows.forEach(function (r) {
            r.dataset.open = 'false';
            var t = r.querySelector('[data-faq-toggle]');
            var p = r.querySelector('[data-faq-panel]');
            if (t) t.setAttribute('aria-expanded', 'false');
            if (p) p.hidden = true;
          });
          if (!isOpen) {
            row.dataset.open = 'true';
            toggle.setAttribute('aria-expanded', 'true');
            var panel = row.querySelector('[data-faq-panel]');
            if (panel) panel.hidden = false;
          }
        });
      });

      // Auto-scroll to form on successful submit
      var success = root.querySelector('.contact-form__success');
      if (success) {
        success.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('.contact-form').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-shipping-stepper"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.shipStepInit === '1') return;
      root.dataset.shipStepInit = '1';

      var pills = root.querySelectorAll('[data-region-toggle]');
      var groups = root.querySelectorAll('[data-region-group]');

      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          var targetRegion = pill.dataset.regionToggle;

          pills.forEach(function (p) {
            var isActive = p.dataset.regionToggle === targetRegion;
            p.classList.toggle('shipping-stepper__region--active', isActive);
            p.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });

          groups.forEach(function (g) {
            var isActive = g.dataset.regionGroup === targetRegion;
            g.dataset.active = isActive ? 'true' : 'false';
            g.hidden = !isActive;
          });
        });
      });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('.shipping-stepper').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-stockists"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.stockistInit === '1') return;
      root.dataset.stockistInit = '1';

      var pills = root.querySelectorAll('[data-stockist-filter]');
      var cards = root.querySelectorAll('[data-stockist-card]');
      var countEl = root.querySelector('[data-stockist-count]');
      var labelEl = root.querySelector('[data-stockist-section-label]');
      var emptyEl = root.querySelector('[data-stockist-empty]');
      var gridEl = root.querySelector('[data-stockist-grid]');

      function applyFilter(regionId, sectionLabel) {
        var shown = 0;
        cards.forEach(function (card) {
          var cardRegion = card.dataset.region || '';
          var match = !regionId || cardRegion === regionId;
          card.dataset.active = match ? 'true' : 'false';
          if (match) shown++;
        });

        if (countEl) countEl.textContent = shown;
        if (labelEl && sectionLabel) labelEl.textContent = sectionLabel;

        if (emptyEl && gridEl) {
          if (shown === 0) {
            emptyEl.hidden = false;
            gridEl.style.display = 'none';
          } else {
            emptyEl.hidden = true;
            gridEl.style.display = '';
          }
        }
      }

      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          var regionId = pill.dataset.stockistFilter || '';
          var sectionLabel = pill.dataset.sectionLabel || '';

          pills.forEach(function (p) {
            var isActive = p === pill;
            p.classList.toggle('stockists__filter--active', isActive);
            p.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });

          applyFilter(regionId, sectionLabel);
        });
      });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('.stockists').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-accessory-main"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function moneyFormat(cents) {
      if (window.Shopify && window.Shopify.formatMoney) {
        return window.Shopify.formatMoney(cents);
      }
      return '$' + (cents / 100).toFixed(2);
    }

    function initSection(root) {
      if (root.dataset.pdpAccInit === '1') return;
      root.dataset.pdpAccInit = '1';

      // Gallery thumbnail swapping
      var featured = root.querySelector('[data-acc-featured]');
      var thumbs = root.querySelectorAll('[data-acc-thumb]');
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          thumbs.forEach(function (t) { t.classList.remove('pdp-acc__thumb--active'); });
          thumb.classList.add('pdp-acc__thumb--active');
          if (featured) {
            featured.src = thumb.dataset.imgUrl;
            featured.removeAttribute('srcset');
            if (thumb.dataset.imgAlt) featured.alt = thumb.dataset.imgAlt;
          }
        });
      });

      // Qty stepper + ATC label
      var qtyInput = root.querySelector('[data-acc-qty]');
      var dec = root.querySelector('[data-acc-dec]');
      var inc = root.querySelector('[data-acc-inc]');
      var subtotalEl = root.querySelector('[data-acc-subtotal]');
      var eachEl = root.querySelector('[data-acc-each]');
      var unitPrice = eachEl ? parseInt(eachEl.dataset.priceCents || '0', 10) : 0;

      function updateSubtotal() {
        if (!qtyInput || !subtotalEl) return;
        var q = parseInt(qtyInput.value, 10) || 1;
        q = Math.max(1, Math.min(99, q));
        qtyInput.value = q;
        subtotalEl.textContent = moneyFormat(unitPrice * q);
      }

      if (dec) dec.addEventListener('click', function () {
        var q = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = Math.max(1, q - 1);
        updateSubtotal();
      });
      if (inc) inc.addEventListener('click', function () {
        var q = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = Math.min(99, q + 1);
        updateSubtotal();
      });
      if (qtyInput) qtyInput.addEventListener('input', updateSubtotal);
      updateSubtotal();

      // ATC submission → ON.cart.add → open cart drawer
      var form = root.querySelector('[data-acc-atc-form]');
      var atcBtn = root.querySelector('[data-acc-atc-btn]');
      if (form) {
        form.addEventListener('submit', function (e) {
          if (!window.ON || !window.ON.cart || !window.ON.cart.add) return; // fallback to native form post
          e.preventDefault();
          var variantInput = root.querySelector('[data-acc-variant-input]');
          var q = parseInt(qtyInput.value, 10) || 1;
          var id = parseInt(variantInput.value, 10);
          if (!id) return;

          if (atcBtn) atcBtn.setAttribute('disabled', 'disabled');

          window.ON.cart.add({ id: id, quantity: q })
            .then(function () {
              if (window.ON.openDrawer) {
                window.ON.openDrawer('cart');
              } else {
                // Fallback — find a drawer-open trigger and click it
                var trigger = document.querySelector('[data-on-drawer-open="cart"]');
                if (trigger) trigger.click();
              }
            })
            .catch(function (err) {
              console.error('[pdp-accessory] add to cart failed', err);
              if (form && form.submit) form.submit(); // fallback to native submit
            })
            .finally(function () {
              if (atcBtn) atcBtn.removeAttribute('disabled');
            });
        });
      }

      // Accordions — single-open
      var rows = root.querySelectorAll('[data-acc-accordion-row]');
      rows.forEach(function (row) {
        var toggle = row.querySelector('[data-acc-accordion-toggle]');
        if (!toggle) return;
        toggle.addEventListener('click', function () {
          var isOpen = row.dataset.open === 'true';
          rows.forEach(function (r) {
            r.dataset.open = 'false';
            var t = r.querySelector('[data-acc-accordion-toggle]');
            var p = r.querySelector('[data-acc-accordion-panel]');
            if (t) t.setAttribute('aria-expanded', 'false');
            if (p) p.hidden = true;
          });
          if (!isOpen) {
            row.dataset.open = 'true';
            toggle.setAttribute('aria-expanded', 'true');
            var panel = row.querySelector('[data-acc-accordion-panel]');
            if (panel) panel.hidden = false;
          }
        });
      });
    }

    function initAll(root) {
      (root || document).querySelectorAll('.pdp-acc').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-comparison-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pctFromClientX(slider, clientX) {
      var rect = slider.getBoundingClientRect();
      var raw = ((clientX - rect.left) / rect.width) * 100;
      return Math.max(0, Math.min(100, raw));
    }

    function setPct(slider, pct) {
      slider.style.setProperty('--compare', pct);
      slider.setAttribute('aria-valuenow', Math.round(pct));
    }

    function initSlider(slider) {
      if (slider.dataset.pdpSliderInit === '1') return;
      slider.dataset.pdpSliderInit = '1';

      var dragging = false;

      slider.addEventListener('mousedown', function (e) {
        dragging = true;
        setPct(slider, pctFromClientX(slider, e.clientX));
        e.preventDefault();
      });
      document.addEventListener('mousemove', function (e) {
        if (dragging) setPct(slider, pctFromClientX(slider, e.clientX));
      });
      document.addEventListener('mouseup', function () {
        dragging = false;
      });

      slider.addEventListener('touchstart', function (e) {
        if (!e.touches.length) return;
        dragging = true;
        setPct(slider, pctFromClientX(slider, e.touches[0].clientX));
      }, { passive: true });
      slider.addEventListener('touchmove', function (e) {
        if (!dragging || !e.touches.length) return;
        setPct(slider, pctFromClientX(slider, e.touches[0].clientX));
        e.preventDefault();
      }, { passive: false });
      slider.addEventListener('touchend', function () {
        dragging = false;
      });
      slider.addEventListener('touchcancel', function () {
        dragging = false;
      });

      slider.addEventListener('keydown', function (e) {
        var current = parseFloat(slider.getAttribute('aria-valuenow') || '50');
        var step = e.shiftKey ? 10 : 5;
        var next = null;
        if (e.key === 'ArrowLeft'  || e.key === 'ArrowDown') next = current - step;
        if (e.key === 'ArrowRight' || e.key === 'ArrowUp')   next = current + step;
        if (e.key === 'Home') next = 0;
        if (e.key === 'End')  next = 100;
        if (next !== null) {
          setPct(slider, Math.max(0, Math.min(100, next)));
          e.preventDefault();
        }
      });
    }

    function initAll(root) {
      (root || document).querySelectorAll('[data-pdp-slider]').forEach(initSlider);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-ingredients-deepdive"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initDeepdive(root) {
      if (root.dataset.pdpDeepdiveInit === '1') return;
      root.dataset.pdpDeepdiveInit = '1';

      var rows = root.querySelectorAll('[data-deepdive-row]');

      rows.forEach(function (row) {
        var toggle = row.querySelector('[data-deepdive-toggle]');
        if (!toggle) return;

        toggle.addEventListener('click', function () {
          var isOpen = row.dataset.open === 'true';

          // Single-open accordion: close all rows first
          rows.forEach(function (r) {
            r.dataset.open = 'false';
            var t = r.querySelector('[data-deepdive-toggle]');
            var p = r.querySelector('[data-deepdive-panel]');
            if (t) t.setAttribute('aria-expanded', 'false');
            if (p) p.hidden = true;
          });

          // If the clicked row was closed, open it
          if (!isOpen) {
            row.dataset.open = 'true';
            toggle.setAttribute('aria-expanded', 'true');
            var panel = row.querySelector('[data-deepdive-panel]');
            if (panel) panel.hidden = false;
          }
        });
      });
    }

    function initAll(root) {
      (root || document).querySelectorAll('[data-pdp-deepdive]').forEach(initDeepdive);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-main"] && !Shopify.designMode) return;
  try {
    
  // Buy-box rating button — scroll to AliReviews widget on the same page.
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-scroll-to-alireviews]');
    if (!trigger) return;
    var target = document.querySelector('.alireviews-review-box');
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-reviews"] && !Shopify.designMode) return;
  try {
    
  // "READ THEM ALL" — scroll to the AliReviews widget on the same page
  // when the anchor is in scroll-mode (data-pdp-reviews-scroll present).
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-pdp-reviews-scroll]');
    if (!trigger) return;
    e.preventDefault();
    var target = document.querySelector('.alireviews-review-box');
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-scents-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(section) {
      var track = section.querySelector('[data-pdp-scents-track]');
      var btn   = section.querySelector('[data-pdp-scents-swipe]');
      if (!track || !btn) return;

      function update() {
        // Hide the button if everything already fits in view.
        var needsScroll = track.scrollWidth > track.clientWidth + 4;
        btn.hidden = !needsScroll;
      }

      btn.addEventListener('click', function () {
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
        if (atEnd) {
          // Wrap back to the start so the user can keep advancing.
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          // One viewport width = 1 card on mobile, ~4 cards on desktop,
          // which is what we want either way. scroll-snap settles it.
          track.scrollBy({ left: track.clientWidth, behavior: 'smooth' });
        }
      });

      // ResizeObserver is more accurate than 'resize' for tracking when the
      // container changes (e.g. font load), but falls back to window resize.
      if ('ResizeObserver' in window) {
        var ro = new ResizeObserver(update);
        ro.observe(track);
      } else {
        window.addEventListener('resize', update, { passive: true });
      }
      update();
    }

    function boot() {
      document.querySelectorAll('.pdp-scents').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }

    // Re-init on section reload in the theme editor
    document.addEventListener('shopify:section:load', function (e) {
      var s = e.target.querySelector('.pdp-scents');
      if (s) init(s);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
